<template>
  <div class="az-potasium__lvl">
    <div class="meter-wrapper">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        width="523.724"
        height="262.513"
        viewBox="0 0 523.724 262.513"
        id="potassium-meter"
        ref="svgRef"
      >
        <defs>
          <clipPath id="clip-path">
            <rect
              id="Rectangle_2"
              data-name="Rectangle 2"
              class="cls-1"
              width="154.533"
              height="226.324"
              transform="translate(260.995 226.324) rotate(180)"
            />
          </clipPath>
          <clipPath id="clip-path-2">
            <rect
              id="Rectangle_3"
              data-name="Rectangle 3"
              class="cls-1"
              width="154.82"
              height="227.963"
            />
          </clipPath>
          <clipPath id="clip-path-3">
            <rect
              id="Rectangle_1"
              data-name="Rectangle 1"
              class="cls-1"
              width="401.441"
              height="200.721"
              transform="translate(0.025)"
            />
          </clipPath>
        </defs>
        <g
          id="Group_5"
          data-name="Group 5"
          transform="translate(-1120.582 -53)"
        >
          <g id="outer-clock" transform="translate(1118 51)">
            <path
              id="Path_7"
              data-name="Path 7"
              class="cls-2"
              d="M6,262.513C6,119.188,122.122,3,265.365,3S524.73,119.188,524.73,262.513"
            />
            <path
              id="Path_8"
              data-name="Path 8"
              class="cls-3"
              d="M54.366,261.957c0-117.637,95.317-213.009,212.887-213.009S480.141,144.32,480.141,261.957"
            />
          </g>
          <g id="HightState" transform="translate(1383.311 87.189)">
            <g id="Group_3" data-name="Group 3" class="cls-4">
              <path
                id="Path_12"
                data-name="Path_12"
                class="cls-5"
                d="M260.995,226.324H214.05c0-79.256-43.28-148.433-107.588-185.437L129.2,0C207.946,44.968,260.995,129.485,260.995,226.324Z"
              />
            </g>
            <path
              id="Path_13"
              data-name="Path_13"
              class="cls-5"
              d="M107.308,40.231a214.194,214.194,0,0,1,106.978,185.64H.054L107.177,40.231h.131Z"
            />
            <path
              id="Path_14"
              data-name="Path_14"
              class="cls-1"
              d="M184.543,55.979l4.952,6.206-6.765,5.39,3.735,4.685,6.766-5.39,4.952,6.206L179.736,87.8l-4.952-6.206L182,75.838l-3.736-4.685-7.215,5.755L166.1,70.7Z"
            />
            <path
              id="Path_15"
              data-name="Path_15"
              class="cls-1"
              d="M201.469,78.112l4.368,6.632-19.712,13-4.368-6.632Z"
            />
            <path
              id="Path_16"
              data-name="Path_16"
              class="cls-1"
              d="M198.025,94.7l.694-.377c7.872-4.271,13.153-.389,16.366,5.549a19.273,19.273,0,0,1,2.458,7.191l-5.062,2.738a19.244,19.244,0,0,0-2.117-5.828c-2.276-4.2-4.442-4.259-7.7-2.5l-.9.487c-3.565,1.935-5.038,3.5-3.4,6.534a6.009,6.009,0,0,0,1.144,1.473l2.336-1.266-1.326-2.458,4.526-2.446,4.806,8.871-10.634,5.755A25.519,25.519,0,0,1,193.6,111.4c-3.711-6.862-3.322-12.5,4.429-16.694Z"
            />
            <path
              id="Path_17"
              data-name="Path_17"
              class="cls-1"
              d="M221.533,113.363l2.92,7.386-8.055,3.176,2.2,5.573,8.056-3.176,2.92,7.386-21.963,8.676L204.692,135l8.591-3.4-2.2-5.573-8.591,3.4-2.92-7.386Z"
            />
          </g>
          <g id="lowState" transform="translate(1120.582 85.55)">
            <path
              id="Path_18"
              data-name="Path_18"
              class="cls-6"
              d="M154.747,41A215.112,215.112,0,0,0,47,227.515H262.773L154.893,41Z"
            />
            <g id="Group_4" data-name="Group 4" class="cls-7">
              <path
                id="Path_19"
                data-name="Path_19"
                class="cls-6"
                d="M0,227.963H47.032A215.534,215.534,0,0,1,154.82,41.183L132.037,0A262.581,262.581,0,0,0,0,227.963Z"
              />
            </g>
            <path
              id="Path_20"
              data-name="Path_20"
              class="cls-1"
              d="M32.914,134.132l2.95-7.387L52.6,133.437l3.145-7.863,5.23,2.085-6.1,15.25Z"
            />
            <path
              id="Path_21"
              data-name="Path_21"
              class="cls-1"
              d="M51.468,120.832l-.719-.378c-7.778-4.12-7.717-10.886-4.949-16.1,2.962-5.584,8.338-8.875,15.848-4.9l.719.378c7.814,4.133,7.753,10.9,4.986,16.128-2.95,5.583-8.338,8.875-15.872,4.876Zm7.375-13.483-1.085-.572c-4.194-2.219-5.9-1.768-7,.3-1.036,1.963-.244,3.816,3.56,5.827l1.061.561c4.4,2.329,6.01,1.634,7.034-.292,1.036-1.963.244-3.816-3.56-5.828Z"
            />
            <path
              id="Path_22"
              data-name="Path_22"
              class="cls-1"
              d="M53.638,90.332,58.319,83.9l12.239,5.693.085-.11-8.838-10.35,3.767-5.193,12.581,5.217.061-.085L69.193,68.962l4.06-5.571L89.113,81.8l-4.718,6.485L72.131,83.042l-.061.085,8.692,10.155-4.742,6.51-22.357-9.46Z"
            />

            <path
              xmlns="http://www.w3.org/2000/svg"
              d="M3.78783 5.53875L2.37217 7.16446L0.497391 5.55766L1.91304 3.93195L0 2.28733L2.0087 0L3.92174 1.62571L5.33739 0L7.21217 1.60681L5.79652 3.23251L11 7.69376L8.9913 10L3.78783 5.53875Z"
              fill="white"
              id="low-state__mul"
            />
          </g>
          <g id="normalState" transform="translate(1252.438 53)">
            <path
              id="Path_23"
              data-name="Path_23"
              class="cls-8"
              d="M22.9,75.608l107.84,188.158L238.584,75.608l.04-.067a214.892,214.892,0,0,0-215.747,0l.04.067Z"
              transform="translate(-0.251 -1.253)"
            />
            <path
              id="Path_24"
              data-name="Path_24"
              class="cls-9"
              d="M130.319,0A259.832,259.832,0,0,0,.563,34.493L23.24,75.454a214.44,214.44,0,0,1,214.278.079L261.273,35.2A259.811,259.811,0,0,0,130.319,0Z"
            />
            <path
              id="Path_25"
              data-name="Path_25"
              class="cls-1"
              d="M47.721,26.554,55.786,24l9.539,8.711.1-.037L62.035,22.01l6.408-2.035L75.607,42.5l-7.09,2.254L57.5,34.765l-.134.037,3.9,12.256L54.9,49.08Z"
              transform="translate(0.355 0.151)"
            />
            <path
              id="Path_26"
              data-name="Path_26"
              class="cls-1"
              d="M76.236,30.608l-.146-.8c-1.6-8.65,3.74-12.792,9.539-13.864,6.2-1.145,12.122,1.011,13.669,9.369l.146.8c1.608,8.686-3.728,12.828-9.527,13.9-6.2,1.145-12.122-1.011-13.669-9.405Zm15.131-2.595-.219-1.206c-.865-4.666-2.278-5.714-4.593-5.287-2.181.4-3.131,2.181-2.351,6.4l.219,1.17c.9,4.9,2.449,5.726,4.593,5.324C91.2,34.007,92.146,32.228,91.366,28.013Z"
              transform="translate(0.567 0.118)"
            />
            <path
              id="Path_27"
              data-name="Path_27"
              class="cls-1"
              d="M102.882,13.609l11.063-.707c6.225-.39,9.466,1.693,9.806,7.005.2,3.167-.986,4.946-3.3,6.225v.134l5.568,9.563-8.138.512-4.288-7.724-1.8.11.512,7.967-7.93.5-1.5-23.586Zm10.587,10.258c1.9-.122,2.632-1.121,2.51-3.058-.122-1.84-.95-2.668-2.924-2.546l-2.01.122L111.4,24Z"
              transform="translate(0.771 0.097)"
            />
            <path
              id="Path_28"
              data-name="Path_28"
              class="cls-1"
              d="M129.8,12.092l10.623.731,2.485,12.037h.134L147.2,13.286l10.514.731L156.076,37.6l-7.833-.548,1.011-14.632h-.134l-5.032,14.351-5.274-.365-2.961-14.948h-.134l-1.011,14.656-6.53-.451L129.81,12.08Z"
              transform="translate(0.962 0.091)"
            />
            <path
              id="Path_29"
              data-name="Path_29"
              class="cls-1"
              d="M171.043,16.553l8.418,1.767,3.01,24.792-7.943-1.669-.353-3.972-7.213-1.523-1.888,3.509-6.883-1.45Zm-1.62,14.79,4.276.9L173.065,25l-.17-.037Z"
              transform="translate(1.188 0.125)"
            />
            <path
              id="Path_30"
              data-name="Path_30"
              class="cls-1"
              d="M191.665,21.427l7.553,2.473-5.6,17.117,8.041,2.631L199.9,49l-15.594-5.1Z"
              transform="translate(1.385 0.161)"
            />
          </g>
          <g id="inner-clock" transform="translate(1182.609 110.792)">
            <path
              id="Path_1"
              data-name="Path 1"
              class="cls-10"
              d="M147.081,136.825l-.9-.813A74,74,0,0,1,163.894,121.7a73.174,73.174,0,0,1,17.451-7.278,74.325,74.325,0,0,1,38.782,0,73.518,73.518,0,0,1,35.162,21.594l-.9.812a72.371,72.371,0,0,0-107.311,0Z"
            ></path>
            <path
              id="Path_2"
              data-name="Path 2"
              class="cls-10"
              d="M153.611,139.356l-13.324,5.158,2.192-14.126Z"
            ></path>
            <path
              id="Path_3"
              data-name="Path 3"
              class="cls-10"
              d="M247.893,139.356l13.31,5.158-2.192-14.126Z"
            ></path>
            <g id="Group_1" data-name="Group 1" class="cls-11">
              <path
                id="Path_4"
                data-name="Path 4"
                class="cls-12"
                d="M1.131,200.72v-.671H21.022Z"
              ></path>
              <path
                id="Path_5"
                data-name="Path 5"
                class="cls-12"
                d="M380.045,187.929l-.084-1.145,19.833-1.514.093,1.27Zm-358.437-1.84L1.781,184.5l.106-1.27L21.7,184.944Zm356.957-11.83-.17-1.132,19.66-3.019.189,1.258ZM23.229,172.435l-19.648-3.1.2-1.257L23.412,171.3Zm352.817-11.685-.257-1.118,19.371-4.519.285,1.242Zm-350.157-1.8-19.352-4.6.3-1.239,19.323,4.72ZM372.5,147.475l-.342-1.093,18.965-6,.38,1.215Zm-342.921-1.76-18.941-6.071.392-1.211,18.9,6.193Zm338.36-11.2-.425-1.064,18.447-7.439.473,1.183ZM34.271,132.8,15.853,125.29l.485-1.178,18.369,7.63Zm328.12-10.86-.506-1.029,17.821-8.835.562,1.143ZM39.946,120.287l-17.786-8.9.574-1.137,17.729,9.018ZM355.9,109.829l-.583-.987L372.4,98.667l.648,1.1Zm-309.33-1.588L29.514,98l.659-1.089,16.986,10.35Zm301.925-9.993-.657-.94L364.1,85.857l.73,1.044Zm-294.4-1.512L37.87,85.223l.74-1.036L54.756,95.8Zm286.134-9.472-.727-.887L354.839,73.72l.807.985ZM62.469,85.839,47.174,73.122l.817-.977L63.205,84.959Zm268.672-8.9-.792-.829,14.336-13.789.88.92ZM71.656,75.609,57.373,61.765l.889-.911L72.457,74.788ZM321.3,67.34l-.853-.766,13.245-14.839.947.851ZM81.594,66.107,68.406,51.217l.956-.841L82.455,65.35Zm229.163-7.593-.909-.7,12.077-15.8,1.009.776ZM92.226,57.391,80.211,41.539l1.017-.766L93.142,56.7Zm207.348-6.872-.959-.628,10.836-16.68,1.066.7ZM103.49,49.511,92.721,32.788l1.073-.686,10.663,16.791ZM287.815,43.4l-1-.552,9.527-17.461,1.116.613Zm-172.491-.888-9.462-17.5,1.122-.6,9.35,17.556Zm160.222-5.307-1.044-.473,8.161-18.14,1.16.526Zm-147.893-.76-8.089-18.172,1.166-.514L128.7,35.985Zm135.188-4.472-1.077-.392L268.5,12.869l1.2.436Zm-122.429-.628-6.665-18.741,1.2-.423,6.545,18.783Zm109.36-3.611-1.1-.308,5.278-19.178,1.228.342Zm-96.247-.491-5.2-19.2,1.231-.329,5.078,19.232Zm82.888-2.729-1.124-.222,3.788-19.527,1.249.246Zm-69.5-.352L163.206,4.624l1.251-.234,3.586,19.565Zm55.926-1.833L221.7,22.2l2.283-19.759,1.265.15Zm-42.334-.213L178.3,2.352l1.267-.137L181.651,22Zm28.629-.933-1.146-.049.782-19.875,1.271.054Zm-14.91-.075-.707-19.878,1.271-.041.582,19.882Z"
              ></path>
              <path
                id="Path_6"
                data-name="Path 6"
                class="cls-12"
                d="M402.348,200.72H382.458l19.891-.671Z"
              ></path>
            </g>
          </g>
          <g
            id="Arrow-clock"
            ref="arrowRef"
            transform="translate(1346.817 116.106)"
          >
            <path
              id="Path_9"
              data-name="Path_9"
              class="cls-13"
              d="M44.967,166.772H29.248V20.464H44.967Z"
            />
            <path
              id="Path_10"
              data-name="Path_10"
              class="cls-13"
              d="M61.537,48.116l-25-25-24.983,25L.441,37,36.54.883,72.653,37Z"
            />
            <g id="Group_2" data-name="Group 2">
              <path
                id="Path_11"
                data-name="Path_11"
                class="cls-13"
                d="M36.541,199.407a21,21,0,1,0-20.987-21A20.994,20.994,0,0,0,36.541,199.407Z"
              />
            </g>
          </g>
        </g>
      </svg>
    </div>

    <div id="state-info" class="state-info az-fade__up">
      <h3 :class="currentState.color">{{ currentState.name }}</h3>
      <p class="az-lead" v-html="currentState.leadText"></p>
      <p v-if="currentState.description" v-html="currentState.description"></p>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, reactive } from "vue";

// Refs for DOM elements
const svgRef = ref(null);
const arrowRef = ref(null);

// States and their rotation angles
const states = reactive({
  low: {
    name: "LOW",
    angle: -66,
    color: "low-color",
    leadText: "Hypokalemia: Blood potassium level less than 3.5 mEq/L",
    description:
      "<sup>†</sup> Like high potassium, low potassium can also potentially cause serious health issues.",
  },
  normal: {
    name: "NORMAL",
    angle: 0,
    color: "normal-color",
    leadText: "Blood potassium level between 3.5 and 5.0 mEq/L<sup>*</sup>",
    description:
      "<sup>*</sup> In some cases, up to 5.2 mEq/L is considered normal.",
  },
  high: {
    name: "HIGH",
    angle: 67,
    color: "high-color",
    leadText: "Hyperkalemia: Blood potassium level more than 5.0 mEq/L",
    description: "",
  },
});

// Reactive state tracking
const currentState = reactive({ ...states.normal });
const isDragging = ref(false);
const currentAngle = ref(0);

// Fixed coordinates for the rotation pivot
const pivotX = 36.541;
const pivotY = 178.407;
const originalTransform = "translate(1346.817 116.106)";

// Helper function to set arrow rotation using SVG transforms
function setArrowRotation(angle) {
  angle = Math.max(-66, Math.min(67, angle));
  currentAngle.value = angle;

  if (arrowRef.value) {
    arrowRef.value.setAttribute(
      "transform",
      `${originalTransform} rotate(${angle} ${pivotX} ${pivotY})`
    );
  }
}

// Helper function to determine state based on arrow angle
function getStateFromAngle(angle) {
  if (angle < -30) {
    return states.low;
  } else if (angle > 30) {
    return states.high;
  } else {
    return states.normal;
  }
}

// Update state visually
function updateStateVisual(state) {
  // Update the reactive state object
  Object.assign(currentState, state);

  // Update SVG state visibility
  const svg = svgRef.value;
  if (svg) {
    const lowStateEl = svg.querySelector("#lowState");
    const normalStateEl = svg.querySelector("#normalState");
    const highStateEl = svg.querySelector("#HightState");

    if (lowStateEl) lowStateEl.style.opacity = "0";
    if (normalStateEl) normalStateEl.style.opacity = "0";
    if (highStateEl) highStateEl.style.opacity = "0";

    // Show only the current state
    if (state === states.low && lowStateEl) lowStateEl.style.opacity = "1";
    if (state === states.normal && normalStateEl)
      normalStateEl.style.opacity = "1";
    if (state === states.high && highStateEl) highStateEl.style.opacity = "1";
  }
}

// Handle click on the potassium meter
function handleClick(event) {
  // Ignore if we're already dragging
  if (isDragging.value) return;

  // Get SVG coordinates
  const svgRect = svgRef.value.getBoundingClientRect();
  const centerX = svgRect.width / 2;

  // Calculate click position relative to SVG
  const clickX = event.clientX - svgRect.left;

  // Determine which third of the clock was clicked
  if (clickX < centerX * 0.7) {
    // Left side clicked - low potassium
    setArrowRotation(states.low.angle);
    updateStateVisual(states.low);
  } else if (clickX > centerX * 1.3) {
    // Right side clicked - high potassium
    setArrowRotation(states.high.angle);
    updateStateVisual(states.high);
  } else {
    // Center area clicked - normal potassium
    setArrowRotation(states.normal.angle);
    updateStateVisual(states.normal);
  }
}

// Mouse/touch event handlers
function startDrag(event) {
  isDragging.value = true;
  event.preventDefault();
}

function startDragTouch(event) {
  if (event.touches.length === 1) {
    const touch = event.touches[0];
    startDrag({
      clientX: touch.clientX,
      clientY: touch.clientY,
      preventDefault: () => event.preventDefault(),
    });
  }
}

function drag(event) {
  if (!isDragging.value || !svgRef.value) return;

  const svgRect = svgRef.value.getBoundingClientRect();
  const centerX = svgRect.width / 2;
  const centerY = svgRect.height;

  const mouseX = event.clientX - svgRect.left;
  const mouseY = event.clientY - svgRect.top;

  let angleDegrees = calculateAngle(mouseX, mouseY, centerX, centerY);
  angleDegrees = Math.max(-66, Math.min(67, angleDegrees));

  setArrowRotation(angleDegrees);

  const newState = getStateFromAngle(angleDegrees);
  if (newState !== currentState) {
    updateStateVisual(newState);
  }
}

function dragTouch(event) {
  if (!isDragging.value || event.touches.length !== 1) return;

  const touch = event.touches[0];
  drag({
    clientX: touch.clientX,
    clientY: touch.clientY,
  });

  event.preventDefault();
}

function endDrag() {
  if (!isDragging.value) return;
  isDragging.value = false;

  // Snap to nearest state
  setArrowRotation(currentState.angle);
}

// Calculate angle between center point and mouse position
function calculateAngle(mouseX, mouseY, centerX, centerY) {
  const deltaX = centerX - mouseX;
  const deltaY = centerY - mouseY;

  // Calculate angle in radians and convert to degrees
  let angle = Math.atan2(deltaY, deltaX) * (180 / Math.PI) - 90;

  // Normalize angle
  if (angle < -180) angle += 360;
  if (angle > 180) angle -= 360;

  // Scale the angle to cover our desired range
  return angle * 0.75;
}

// Setup event listeners after mount
onMounted(() => {
  if (!arrowRef.value || !svgRef.value) return;

  // Add pointer cursor
  arrowRef.value.style.cursor = "pointer";
  svgRef.value.style.cursor = "pointer";

  // Add click handler to the SVG
  svgRef.value.addEventListener("click", handleClick);

  // Mouse events
  arrowRef.value.addEventListener("mousedown", startDrag);
  document.addEventListener("mousemove", drag);
  document.addEventListener("mouseup", endDrag);

  // Touch events
  arrowRef.value.addEventListener("touchstart", startDragTouch);
  document.addEventListener("touchmove", dragTouch);
  document.addEventListener("touchend", endDrag);

  // Set initial state
  updateStateVisual(states.normal);
  setArrowRotation(states.normal.angle);

  // Cleanup function
  return () => {
    if (arrowRef.value) {
      arrowRef.value.removeEventListener("mousedown", startDrag);
      arrowRef.value.removeEventListener("touchstart", startDragTouch);
    }
    if (svgRef.value) {
      svgRef.value.removeEventListener("click", handleClick);
    }
    document.removeEventListener("mousemove", drag);
    document.removeEventListener("mouseup", endDrag);
    document.removeEventListener("touchmove", dragTouch);
    document.removeEventListener("touchend", endDrag);
  };
});
</script>
<style>
.clock-wrapper {
  position: relative;
  width: 518px;
  height: 259px;
}

.meter-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  padding: 20px;
  max-width: 600px;
}

/* SVG styling */
svg {
  max-width: 100%;
  height: auto;
  user-select: none;
  touch-action: none; /* Prevents default touch actions on mobile */
}

/* Style for draggable arrow */
#Arrow-clock {
  cursor: pointer;
}

/* Make sure states transition smoothly */
g#lowState,
g#normalState,
g#HightState {
  transition: opacity 0.3s ease;
}

/* State information styling */
.state-info {
  text-align: center;
  margin-top: 20px;
  padding: 10px;
  max-width: 80%;
  margin-left: auto;
  margin-right: auto;
  min-height: 150px;
}

.state-info h3 {
  font-size: 32px;
  margin-bottom: 10px;
  font-family: "Guardian Text Sans Web";
  font-weight: 500;
  text-transform: uppercase;
}

.state-info p {
  font-size: 20px;
  color: #333;
  margin-top: 5px;
  margin-bottom: 8px;
}

.state-info .az-lead {
  font-weight: 500;
  font-size: 25px;
  color: #000;
}

/* State colors */
.low-color {
  color: #a8c9c5; /* Match the low state color */
}

.normal-color {
  color: #199fe3; /* Match the normal state color */
}

.high-color {
  color: #ff0101; /* Match the high state color */
}

/* Make sure touch events work properly on mobile */
@media (max-width: 768px) {
  .meter-wrapper {
    padding: 10px;
  }

  svg {
    width: 90%;
  }

  .state-info {
    max-width: 90%;
  }

  .state-info h2 {
    font-size: 20px;
  }

  .state-info p {
    font-size: 14px;
  }
}

/* SVG specific styles moved from inline */
#potassium-meter .cls-1 {
  fill: #fff;
}
#potassium-meter .cls-2 {
  fill: #e3edfd;
}
#potassium-meter .cls-3 {
  fill: #f1f2f2;
}
#potassium-meter .cls-4 {
  clip-path: url(#clip-path);
}
#potassium-meter .cls-5 {
  fill: #ff0101;
}
#potassium-meter .cls-6 {
  fill: #a8c9c5;
}
#potassium-meter .cls-7 {
  clip-path: url(#clip-path-2);
}
#potassium-meter .cls-8 {
  fill: #199fe3;
}
#potassium-meter .cls-9 {
  fill: rgba(19, 156, 226, 0.97);
}
#potassium-meter .cls-10 {
  fill: #c72263;
}
#potassium-meter .cls-11 {
  clip-path: url(#clip-path-3);
}
#potassium-meter .cls-12 {
  fill: #224a4a;
}
#potassium-meter .cls-13 {
  fill: #003a45;
}
</style>
